import React, { useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useLocation } from "react-router-dom";

const images = [
  {
    url: "https://adawall.ma/uploads/wallpapers/hue/24207/24207-2/24207-2.3.jpg",
    text: "Transformez vos murs transformez votre vie",
    subtitle: "Découvrez nos collections exclusives."
  },
  {
    url: "https://adawall.ma/uploads/posters/6-Seasons/SE307/SE307-3%2B23210-3.jpg",
    text: "Donnez du style à chaque pièce avec Adawall",
    subtitle: "Un style unique pour chaque espace."
  },
  {
    url: "https://adawall.ma/uploads/adapanel/PS%20ADAPANEL%20VOL.2/802/802-2.jpg",
    text: "Des textures et couleurs pour sublimer votre intérieur",
    subtitle: "Découvrez nos produits phares."
  },
  {
    url: "https://adawall.ma/uploads/moulding/MG2008/MG2008-1.jpg",
    text: "Adawall la touche finale pour un intérieur parfait",
    subtitle: "Découvrez nos projets réalisés."
  },
  {
    url: "https://adawall.ma/uploads/adahome/cushions/EY303-1/EY303-1.jpg",
    text: "Inspirez, décorez, vivez avec nos papiers peints",
    subtitle: "Découvrez notre savoir-faire."
  },
  {
    url: "https://adawall.ma/uploads/wallpapers/icon/24107/24107-2/24107-2-int2.jpg",
    text: "L’élégance murale à portée de main",
    subtitle: "Contactez-nous pour plus d'informations."
  }
];

const categories = [
  {
    title: "PAPIER PEINT PREMIUM",
    subtitle: "CHICS INTERIEURS",
    image: "https://adawall.ma/uploads/wallpapers/icon/24104/24104-3/24104-3-int2.jpg",
    link: "/collections/papierpeint",
  },
  {
    title: "POSTERS",
    subtitle: "COZIFIER VOS MURS",
    image: "https://adawall.ma/uploads/posters/3-Fiji/FJ319/Interior.jpg",
    link: "/collections/poster",
  },
  {
    title: "BARDAGE CONTEMPORAIN",
    subtitle: "PANNEAUX N&M",
    image: "https://adawall.ma/uploads/adapanel/PS%20ADAPANEL%20VOL.2/807/807.jpg",
    link: "/collections/bardage",
  },
  {
    title: "EFFET MOULURE",
    subtitle: "LUXE ARCHI",
    image: "https://adawall.ma/uploads/moulding/MG2011/MG2011-1.jpg",
    link: "/collections/moulure",
  },
  {
    title: "COUSSINS & POUFS",
    subtitle: "CONFORT COUTURE",
    image: "https://adawall.ma/uploads/adahome/poufs/PUF301-1/PUF301-1-2.jpg",
    link: "/collections/coussinsETpoufs",
  },
  {
    title: "ACCESSOIRES DE MAISON",
    subtitle: "DÉCOR ÉLITE",
    image: "https://adawall.ma/uploads/accessoires/Place%20mats/ASK2103/3.jpg",
    link: "/collections/accessoires",
  },
];

function Homepage() {
  const [current, setCurrent] = useState(0);
  const [isLeaving, setIsLeaving] = useState(false);
  const sliderRef = useRef(null);
  const autoScrollTimeout = useRef(null);


const location = useLocation();

useEffect(() => {
  if (location.hash === "#categories-section") {
    const section = document.getElementById("categories-section");
    if (section) {
      setTimeout(() => {
        section.scrollIntoView({ behavior: "smooth" });
      }, 200);
    }
  }
}, [location]);
  // Auto scroll après 5s d'inactivité
  useEffect(() => {
    clearTimeout(autoScrollTimeout.current);
    autoScrollTimeout.current = setTimeout(() => {
      if (sliderRef.current) {
        sliderRef.current.slickNext();
      }
    }, 5000);
    return () => clearTimeout(autoScrollTimeout.current);
  }, [current]);

  // Reset timer à chaque interaction utilisateur
  const handleUserInteraction = () => {
    clearTimeout(autoScrollTimeout.current);
    autoScrollTimeout.current = setTimeout(() => {
      if (sliderRef.current) {
        sliderRef.current.slickNext();
      }
    }, 5000);
  };

  

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    beforeChange: () => {
      setIsLeaving(true);
      handleUserInteraction();
    },
    afterChange: (index) => {
      setCurrent(index);
      setIsLeaving(false);
    },
    onSwipe: handleUserInteraction,
    customPaging: i => (
      <div
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          background: "#bbb",
          margin: "0 3px"
        }}
      ></div>
    ),
    dotsClass: "slick-dots custom-dots",
    prevArrow: <button className="slick-prev" onClick={handleUserInteraction}><span className="arrow"></span></button>,
    nextArrow: <button className="slick-next" onClick={handleUserInteraction}><span className="arrow"></span></button>
  };

  return (
    <>
      
        <div
          style={{
            position: 'relative',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            minHeight: '400px',
            maxHeight: '100vh',
            zIndex: 0,
            overflow: 'hidden'
          }}
        >
        <Slider ref={sliderRef} {...settings}>
          {images.map((img, idx) => (
            <div
              key={idx}
              style={{
                position: 'relative',
                width: '100vw',
                height: '100vh',
                overflow: 'hidden'
              }}
            >
              <img
                src={img.url}
                alt={img.text}
                style={{
                  width: '100vw',
                  height: '100vh',
                  objectFit: 'cover',
                  filter: 'brightness(0.8)',
                  objectPosition: idx === 0 ? 'center bottom' : 'center center'
                }}
              />
            </div>
          ))}
        </Slider>

        {/* Texte centré avec effet personnalisé */}
        <div
          key={current}
          className={`slider-text ${isLeaving ? "leave-animation" : "enter-animation"}`}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: '#fff',
            textAlign: 'center',
            width: '90vw',
            zIndex: 2,
            pointerEvents: 'none'
          }}
        >
          <div
            className="slider-title"
            style={{
              fontSize: '2rem',
              fontWeight: 520,
              fontFamily:'Nunito, sans-serif',
              marginBottom: '18px',
              letterSpacing: '2px',
              textShadow: '0 2px 16px rgba(0,0,0,0.18)',
              animation: isLeaving
                ? 'fadeOutScale 0.5s forwards'
                : 'fadeInScale 0.7s forwards'
            }}
          >
            {images[current].text}
          </div>
          <div
            className="slider-subtitle"
            style={{
              fontSize: '1.1rem',
              fontWeight: 400,
              fontFamily:'Nunito, sans-serif',
              marginBottom: '18px',
              textShadow: '0 2px 8px rgba(0,0,0,0.12)',
              animation: isLeaving
                ? 'fadeOutScale 0.5s forwards'
                : 'fadeInScale 0.7s forwards'
            }}
          >
            {images[current].subtitle}
          </div>
          <a
            href="#categories-section"
            className="slider-btn"
            style={{
              display: 'inline-block',
              padding: '12px 32px',
              background: '#96292A',
              color: '#fff',
              fontWeight: 600,
              fontSize: '1.1rem',
              textDecoration: 'none',
              boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
              marginTop: '12px',
              pointerEvents: 'auto',
              transition: 'background 0.2s'
            }}
            onClick={e => {
              e.preventDefault();
              const section = document.getElementById("categories-section");
              if (section) section.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Découvrir
          </a>
        </div>
      </div>
      <div className="categories-grid" id="categories-section">
        {categories.map((cat, idx) => (
          <div className="category-card" key={idx}>
            <img src={cat.image} alt={cat.title} />
            <div className="category-overlay">
              <div className="category-subtitle">{cat.subtitle}</div>
              <div className="category-title">{cat.title}</div>
              <a href={cat.link} className="category-btn">DÉCOUVREZ</a>
            </div>
          </div>
        ))}
      </div>
      <a
        href="https://wa.me/212664664692"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="/assets/icons/whatsapp.png"
          alt="WhatsApp"
          style={{ width: 40, height: 40 }}
        />
      </a>
      {/* Effets personnalisés pour le texte du slider */}
      <style>
        {`
          @keyframes fadeInScale {
            from { opacity: 0; transform: scale(0.95);}
            to { opacity: 1; transform: scale(1);}
          }
          @keyframes fadeOutScale {
            from { opacity: 1; transform: scale(1);}
            to { opacity: 0; transform: scale(0.95);}
          }
          .slider-text .slider-title,
          .slider-text .slider-subtitle {
            will-change: opacity, transform;
          }
          @media (max-width: 900px) {
            .slider-text {
              top: 18%;
              width: 95vw;
            }
            .slider-title {
              font-size: 1.5rem !important;
            }
            .slider-subtitle {
              font-size: 1rem !important;
            }
          }
         @media (max-width: 600px) {
            .slider-text {
              top: 10%;
              width: 98vw;
            }
            .slider-title {
              font-size: 1.1rem !important;
            }
            .slider-subtitle {
              font-size: 0.9rem !important;
            }
          }
        `}
      </style>
    </>
  );
}

export default Homepage;